import React, { useEffect, useState } from 'react'
import { CodeSnippet } from '../components/code-snippet'
import { PageLayout } from '../components/page-layout'
import { getProductResourceAuth } from '../services/message.service'
import { useAuth0 } from '@auth0/auth0-react'

const audience = process.env.REACT_APP_AUTH0_AUDIENCE
const redirectUri = `https://${process.env.REACT_APP_AUTH0_CALLBACK_URL}`

export const ProductPageAuth: React.FC = () => {
  const [message, setMessage] = useState<string>('')
  const { getAccessTokenSilently, user } = useAuth0()
  console.log('>>>>>>>>>> user = ', user)

  useEffect(() => {
    let isMounted = true

    const getMessage = async () => {
      // const testToken = 'jbhU^cvgrJK8uo0BJHvtrD3fhVHJYi7H.UII**FT$%^&NngvhgvhTdT$776874gFcCGrdr'
      const accessToken = await getAccessTokenSilently({
        authorizationParams: {
          redirect_uri: redirectUri,
          scope: 'openid profile email picture website locale phone_number phone_number_verified address',
          audience,
        },
      })

      const { data, error } = await getProductResourceAuth(accessToken)

      if (!isMounted) {
        return
      }

      if (data) {
        setMessage(JSON.stringify(data, null, 2))
      }

      if (error) {
        setMessage(JSON.stringify(error, null, 2))
      }
    }

    getMessage()

    return () => {
      isMounted = false
    }
  }, [getAccessTokenSilently])

  return (
    <PageLayout>
      <div className="content-layout">
        <h1 id="page-title" className="content__title">
          Product Page
        </h1>
        <div className="content__body">
          <p id="page-description">
            <span>
              This page retrieves an <strong>product message</strong> from an AWS API.
            </span>
            <span>
              <strong>
                Only authenticated users with the <code>read:admin-messages</code> permission should access this page.
              </strong>
            </span>
          </p>
          <CodeSnippet title="Product Message" code={message} />
        </div>
      </div>
    </PageLayout>
  )
}
